import React, { FC, useEffect } from 'react';
import { useIntl } from 'react-intl';
import { EventsGrid } from '../../../Events/components/EventsGrid/EventsGrid';
import { getEvent, getEvents } from '../../api/event';
import { EventContent } from '../../components/EventContent/EventContent';
import { EventHeader } from '../../components/EventHeader/EventHeader';
import { EventInfo } from '../../components/EventInfo/EventInfo';
import { EventSkeleton } from '../../components/EventSkeleton/EventSkeleton';
import { definedTranslation } from '../../i18n';
import {
  eventDataSelector,
  eventLoadedSelector,
  eventErrorSelector,
  eventsDataSelector,
} from '../../redux/event/eventSelector';
import { useAppDispatch, useAppSelector } from '../../redux/store';

const getSlug = () => {
  const pathArr = window.location.pathname?.split('/');
  const slug = pathArr?.pop();
  return slug === '' ? pathArr?.pop() : slug;
};

export const EventContainer: FC = () => {
  const slug = getSlug();
  const dispatch = useAppDispatch();
  const eventData = useAppSelector(eventDataSelector);
  const eventError = useAppSelector(eventErrorSelector);
  const isEventLoading = !useAppSelector(eventLoadedSelector);

  const eventsData = useAppSelector(eventsDataSelector);
  const error = eventError ? true : false;

  const loadEventData = () => {
    // @ts-expect-error // TODO: fix types
    dispatch(getEvent(slug));
    dispatch(getEvents());
  };

  useEffect(() => {
    loadEventData();
  }, []);

  if (!slug) {
    return <div className="mt-4 text-center">Event not found</div>;
  }

  if (error) {
    return <div className="mt-4 text-center">Error: {eventError}</div>;
  }

  if (isEventLoading) {
    return <EventSkeleton />;
  }

  if (!eventData) {
    return <div className="mt-4 text-center">Event not found</div>;
  }

  const intl = useIntl();
  const titleEvents = intl?.formatMessage(
    definedTranslation.title.eventsBottom,
  );

  return (
    <>
      <EventHeader event={eventData} />
      <EventContent event={eventData} />
      <EventInfo event={eventData} />
      <EventsGrid events={eventsData} title={titleEvents} isFeatured={false} />
    </>
  );
};
